import { render, staticRenderFns } from "./SeminarDashboardNew.vue?vue&type=template&id=278be582"
import script from "./SeminarDashboardNew.vue?vue&type=script&lang=js"
export * from "./SeminarDashboardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports